/* This file is auto-generated. Do not edit directly. */
/* eslint-disable */
export enum QueryCommitStatus {
  JobNotFound = 'JobNotFound',
  Error = 'Error',
  CompletedOk = 'CompletedOk',
  Prepared = 'Prepared',
  InProgress = 'InProgress',
  WaitingForPickup = 'WaitingForPickup',
  PaymentRequired = 'PaymentRequired'
}

